import { linkUrl, telNumber } from "./links";

export interface VCardFields {
  first: string;
  last: string;
  org: string;
  job: string;
  phone: string;
  email: string;
  website: string;
  address: string;
  note: string;
}

// Version 3.0 rather than 4.0: it is what every phone's own importer was written against, and a contact that will
// not open is worth more than one that is current. CRLF is what RFC 2426 ends a line with, and the byte it costs
// per line is the price of a card a strict reader will take. Nothing is folded at 75 octets as that RFC also asks,
// a fold being three more bytes per line for the benefit of readers no camera is attached to.
export function writeVCard(fields: VCardFields): string {
  const full = [fields.first.trim(), fields.last.trim()].filter(Boolean).join(" ");
  const org = fields.org.trim();
  if (!full && !org) return "";
  const lines = ["BEGIN:VCARD", "VERSION:3.0"];
  // Both are required by the format even where there is no person: an organisation's card has a blank N above it.
  lines.push(`N:${escape(fields.last.trim())};${escape(fields.first.trim())};;;`);
  lines.push(`FN:${escape(full || org)}`);
  if (org) lines.push(`ORG:${escape(org)}`);
  if (fields.job) lines.push(`TITLE:${escape(fields.job)}`);
  if (fields.phone) lines.push(`TEL;TYPE=CELL:${escape(telNumber(fields.phone))}`);
  if (fields.email) lines.push(`EMAIL;TYPE=INTERNET:${escape(fields.email.trim())}`);
  if (fields.website) lines.push(`URL:${escape(linkUrl(fields.website) ?? fields.website.trim())}`);
  // One box into the street component, seven boxes for the seven the format has being a form nobody would fill in.
  if (fields.address) lines.push(`ADR;TYPE=HOME:;;${escape(fields.address)};;;;`);
  if (fields.note) lines.push(`NOTE:${escape(fields.note)}`);
  lines.push("END:VCARD");
  return lines.join("\r\n");
}

// The four the format gives a meaning to inside a value, the semicolon and comma being what it separates parts and
// lists with. A colon is not among them: it only separates the name of a property from the value, once per line.
function escape(value: string): string {
  return value.replace(/([\\;,])/g, "\\$1").replace(/\r?\n/g, "\\n");
}
